/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_compound_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free compound interest calculator. Enter principal, rate, time and compounding frequency to see the final amount and interest earned.`)
};

const es_sip_compound_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de interés compuesto gratuita. Ingresa principal, tasa, tiempo y frecuencia de composición para ver el monto final e interés ganado.`)
};

const de_sip_compound_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Zinseszins-Rechner. Geben Sie Kapital, Zinsatz, Zeit und Zerlegungshäufigkeit ein, um den Endbetrag und verdiente Zinsen zu sehen.`)
};

const nl_sip_compound_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis samengestelde rentecalculator. Voer hoofdsom, tarief, periode en samenstellingsfrequentie in om het eindvermogen en verdiende rente te zien.`)
};

const fr_sip_compound_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrice d'intérêt composé gratuite. Entrez le principal, le taux, la durée et la fréquence de composition pour voir le montant final et les intérêts gagnés.`)
};

const it_sip_compound_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore interesse composto gratuito. Inserisci il capitale, il tasso, il tempo e la frequenza di capitalizzazione per vedere l'importo finale e l'interesse guadagnato.`)
};

const pt_br2_sip_compound_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de juros compostos gratuita. Digite principal, taxa, tempo e frequência de composição para ver o valor final e juros ganhos.`)
};

const pt_sip_compound_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de juro composto gratuita. Introduza principal, taxa, tempo e frequência de capitalização para ver o montante final e juro auferido.`)
};

const ja_sip_compound_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の複利計算機。元本、利率、期間、複利頻度を入力して、最終金額と利息を確認します。`)
};

const zh_sip_compound_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费复利计算器。输入本金、利率、时间和复利频率，查看最终金额和利息收入。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_compound_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_compound_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_compound_meta_description", locale)
	if (locale === "en") return en_sip_compound_meta_description(inputs)
	if (locale === "es") return es_sip_compound_meta_description(inputs)
	if (locale === "de") return de_sip_compound_meta_description(inputs)
	if (locale === "nl") return nl_sip_compound_meta_description(inputs)
	if (locale === "fr") return fr_sip_compound_meta_description(inputs)
	if (locale === "it") return it_sip_compound_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_sip_compound_meta_description(inputs)
	if (locale === "pt") return pt_sip_compound_meta_description(inputs)
	if (locale === "ja") return ja_sip_compound_meta_description(inputs)
	return zh_sip_compound_meta_description(inputs)
};